exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thubnail {\n  transform: translate(-38%, -38%) scale(0.2); }\n\n.browser {\n  border: 1px solid gray;\n  display: flex;\n  flex-direction: column;\n  height: 630px;\n  width: 100%;\n  position: relative;\n  overflow: auto;\n  border-radius: 5px; }\n  .browser .nav-bar {\n    display: flex;\n    height: 30px;\n    background-color: darkgrey;\n    width: 100%; }\n    .browser .nav-bar .icon {\n      border-radius: 50%;\n      border: 0.3px solid;\n      width: 14px;\n      height: 14px;\n      min-height: 14px;\n      min-width: 14px;\n      margin-left: 7px;\n      margin-top: 7px; }\n      .browser .nav-bar .icon.red {\n        background-color: red; }\n      .browser .nav-bar .icon.yellow {\n        background-color: yellow; }\n      .browser .nav-bar .icon.green {\n        background-color: green; }\n    .browser .nav-bar .url {\n      width: 80%;\n      background-color: white;\n      height: 20px;\n      min-height: 20px;\n      margin-top: 4px;\n      margin-left: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Canvas/Canvas.scss
// module id = 536
// module chunks = 0